<template>
  <div class="didiPriceRelateOthersSelect">
    <rich-checkbox-group v-model="data" @input="dataChange">
      <div v-for="(item, index) in options" :key="index">
        <rich-checkbox :option="item"/>
        <span
          class="check-required"
          v-if="index === (options.length - 1) && isChecked(item.value)"
        >*</span>
        <rich-input :maxlength="300" :ref="item.value" v-if="index === (options.length - 1) && isChecked(item.value)" v-model="remark[item.value]" @blur="remarkChange" :placeholder="gettext('请输入')"/>
        <div
          class="error-msg"
          v-if="showErr && index === (options.length - 1) && isChecked(item.value)"
          v-text="errmsg"
        ></div>
      </div>
    </rich-checkbox-group>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        data: [],
        remark: {},
        showErr: false,
        errmsg: this.gettext('选项和输入框不能为空')
      }
    },
    props: {
      options: {},
      value: {
        required: false,
        type: [String, Array, Object]
      }
    },
    watch: {
      value (nVal) {
        this.initValue(nVal)
      }
    },
    created () {
      this.initValue(this.value)
    },
    methods: {
      dataChange () {
        this.change()
      },

      remarkChange () {
        this.change()
      },

      initValue (val = []) {
        const data = []
        val.forEach(item => {
          for (let key in item) {
            data.push(key)
            this.remark[key] = item[key]
          }
        })
        this.data = data
      },
      getValue () {
        const data = []
        this.data.forEach(item => {
          console.log('item =>', item)
          data.push({
            [item]: this.remark[item] || ''
          })
        })
        console.log('item =>', data)
        return data
      },
      change () {
        let value = this.getValue()
        this.$emit('input', value)
      },
      isChecked (value) {
        return this.data.includes(value)
      },
      validate (cb) {
        let value = this.getValue()
        let pass = true
        if (!value) pass = false
        else {
          for (let i = 0; i < value.length; i++) {
            const item = value[i]
            for (let key in item) {
              if (this.$refs && this.$refs[key] && this.$refs[key][0] && !item[key]) {
                this.showErr = pass
                pass = false
                // break
                return pass
              }
            }
            // if (!pass) break
          }
        }
        cb && pass && cb(pass)
        this.showErr = !pass
        return pass
      }
    }
  }
</script>

<style lang="scss" scoped>
.error-msg {
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}
.check-required {
  color: #e64340;
  position: relative;
  top: 54Px;
  z-index: 1;
}
</style>
